(function () {
  var KEY = 'wanderbag_recently_viewed';

  function formatJPY(cents) {
    if (cents == null) return '';
    var yen = Math.round(cents / 100);
    return '¥' + yen.toLocaleString('ja-JP') + ' JPY';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function buildCard(item, slideId) {
    var li = document.createElement('li');
    li.id = slideId;
    li.className = 'slider__slide';
    var onSale = item.compareAtPrice && item.compareAtPrice > item.price;
    var badgesHtml = '';
    li.innerHTML =
      '<a class="rv-card" href="' + item.url + '">' +
        '<div class="rv-card__media">' +
          badgesHtml +
          (item.image ? '<img src="' + item.image + '" alt="" loading="lazy" width="400" height="400">' : '') +
        '</div>' +
        '<h3 class="rv-card__title card__heading h5">' + escapeHtml(item.title) + '</h3>' +
        '<p class="rv-card__price price' + (onSale ? ' rv-card__price--sale' : '') + '">' +
          (onSale ? '<span class="rv-card__price-compare">' + formatJPY(item.compareAtPrice) + '</span>' : '') +
          formatJPY(item.price) +
        '</p>' +
      '</a>';
    return li;
  }

  document.querySelectorAll('.rv-section').forEach(function (section) {
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { list = []; }

    var currentHandleMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (currentHandleMatch) {
      var currentHandle = currentHandleMatch[1];
      list = list.filter(function (it) { return it.handle !== currentHandle; });
    }

    if (!list.length) return;

    var max = parseInt(section.dataset.max, 10) || 8;
    var grid = section.querySelector('.rv-grid');
    var sliderComponent = section.querySelector('slider-component');
    var sectionId = section.dataset.sectionId;
    list.slice(0, max).forEach(function (item, i) {
      grid.appendChild(buildCard(item, 'Slide-' + sectionId + '-' + (i + 1)));
    });
    section.style.display = '';
    if (sliderComponent && typeof sliderComponent.resetPages === 'function') {
      var doReset = function () { sliderComponent.resetPages(); };
      if (document.readyState === 'complete') {
        setTimeout(doReset, 0);
      } else {
        window.addEventListener('load', doReset, { once: true });
      }
    }
  });
})();

